var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-dialog", {
    attrs: {
      title: _vm.title,
      visible: _vm.dialogVisible,
      width: "25%",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c("el-form", {
    ref: "form",
    attrs: {
      "status-icon": "",
      model: _vm.form,
      rules: _vm.rules,
      "label-width": "120px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "平台银行打款回单",
      prop: "bankReceiptImg"
    }
  }, [_c("el-upload", {
    attrs: {
      "on-success": _vm.handleAvatarSuccess,
      "before-upload": _vm.beforeAvatarUpload,
      headers: _vm.uploadHeaders,
      "file-list": _vm.fileList,
      action: _vm.uploadUrl + "admin/v1/file/uploadFileImg",
      "list-type": "picture-card",
      "on-remove": _vm.handleRemove
    }
  }, [_c("i", {
    staticClass: "el-icon-plus"
  })])], 1), _c("el-form-item", {
    attrs: {
      label: "打款时间",
      prop: "paymentDate"
    }
  }, [_c("el-date-picker", {
    attrs: {
      type: "date",
      "value-format": "yyyy-MM-dd",
      placeholder: "选择日期"
    },
    model: {
      value: _vm.form.paymentDate,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "paymentDate", $$v);
      },
      expression: "form.paymentDate"
    }
  })], 1)], 1), _c("div", {
    staticClass: "bottomDiv"
  }, [_c("el-button", {
    on: {
      click: _vm.handleClose
    }
  }, [_vm._v("关闭")]), _c("el-button", {
    attrs: {
      disabled: _vm.disabled,
      type: "primary"
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v("保存")])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };